import { useDesign } from '../../hooks';
import {
  DesignIntent,
  DesignIntentConfig,
  Option
} from '../../types';
import {
  HierarchyType,
  LinkIntentHierarchyList
} from './link-intent-hierarchy-list';
import styles from './LinkIntentHierarchy.module.scss';

export interface LinkIntentHierarchyProps {
  disabled: boolean;
  intentConfig: DesignIntentConfig;
  onConfigChange: <K extends keyof(DesignIntentConfig)>(
    changes: Pick<DesignIntentConfig, K>
  ) => void;
}

export function LinkIntentHierarchy({
  disabled,
  intentConfig,
  onConfigChange
}: LinkIntentHierarchyProps) {
  const design = useDesign();
  const relatedIds = new Set([
    ...intentConfig.children,
    ...intentConfig.parents
  ].map(({ customId }) => {
    return customId;
  }));

  const onSearch = (
    inputValue: string
  ): Option<DesignIntent>[] => {
    return design.components.intents.filter(({ id, name }) => {
      return (
        !relatedIds.has(id)
        // Case-insensitive search
        && new RegExp(inputValue, 'ig').test(name)
      );
    }).map((designIntent) => ({
      id: designIntent.id,
      label: designIntent.name,
      value: designIntent
    }));
  };

  return (
    <div className={styles.container}>
      <LinkIntentHierarchyList
        intentConfig={intentConfig}
        onConfigChange={onConfigChange}
        onSearch={onSearch}
        type={HierarchyType.parents}
        disabled={disabled}
      />
      <LinkIntentHierarchyList
        intentConfig={intentConfig}
        onConfigChange={onConfigChange}
        onSearch={onSearch}
        type={HierarchyType.children}
        disabled={disabled}
      />
    </div>
  );
}
